import { isSamePort } from './portGroups.js';

// Does a rate's origin/destination match one picked in the Rates page's Origin & Destination filter?
// Door locations (type 'postcode', e.g. NZ:4396:tahora) match by id; before, they weren't handled,
// so picking a suburb from "Door Locations" showed no rates at all.
export function rateLocationMatches({ location, filter, incEverywhere }) {
    if (incEverywhere && !location) return true;
    if (filter.type === 'port') return isSamePort(location?.id, filter.id);
    if (filter.type === 'unlocode') return isSamePort(location?.id, filter.id);
    if (filter.type === 'country') return location?.countryCode === filter.countryCode;
    if (filter.type === 'postcode') return location?.type === 'postcode' && location?.id === filter.id;
    return false;
}
